import { Chip, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useIsConvelioSupplier } from 'src/app/hooks/useIsConvelioSupplier';
import { translations } from 'src/locales/translations';

type Props = {
  isInsured?: boolean;
};

/**
 * Green "Insured" chip surfaced on a booking when its linked Salesforce order
 * is insured. Internal Convelio supplier teams (Le Bourget / Heathrow) only.
 */
export const InsuranceFlag = ({ isInsured }: Props): JSX.Element | null => {
  const { t } = useTranslation();
  const isConvelioSupplier = useIsConvelioSupplier();

  if (!isConvelioSupplier || !isInsured) {
    return null;
  }

  return (
    <InsuranceChipStyled
      data-testid="insurance-flag"
      label={t(translations.insured)}
    />
  );
};

const InsuranceChipStyled = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.success.light,
  color: theme.palette.success.dark,
  marginLeft: 4,
  paddingX: 8,
  paddingY: 4,
  fontSize: '0.8rem',
  lineHeight: '1.09rem',
  fontWeight: 600,
  height: 24
}));
